import { render, staticRenderFns } from "./pageHome.vue?vue&type=template&id=69024fd4&scoped=true"
import script from "./pageHome.vue?vue&type=script&lang=js"
export * from "./pageHome.vue?vue&type=script&lang=js"
import style0 from "./pageHome.vue?vue&type=style&index=0&id=69024fd4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69024fd4",
  null
  
)

export default component.exports